import api from 'api';

export const loadPresets = ({ presetKey, ...rest }, { signal }) =>
  api(`GET /api/profile/presets`)(
    {
      key: `presets.${presetKey}`,
      ...rest,
    },
    { signal }
  );

export const savePreset = api(`POST /api/profile/presets`);
export const editPreset = api(`PUT /api/profile/presets/:id`);
export const deletePreset = async (id) =>
  api(`DELETE /api/profile/presets/${id}`)();
export const updateUsageDatePreset = api(
  'GET /api/profile/presets/:id/update-usage-date'
);

export const loadGroups = (screen) =>
  api('GET /api/profile/presets/groups')({
    key: `presets.${screen}`,
  });

export const loadGroupedPresets = ({ presetKey, ...rest }, { signal }) =>
  api(`GET /api/profile/presets/grouped`)(
    {
      key: `presets.${presetKey}`,
      ...rest,
    },
    { signal }
  );

export const createGroup = api('POST /api/profile/presets/groups');
export const editGroup = api(`PUT /api/profile/presets/groups/:id`);
export const deleteGroup = api(`DELETE /api/profile/presets/groups/:id`);
export const moveToAnotherGroup = api(`POST /api/profile/presets/togroup`);
export const moveToUngroupedGroup = api(
  `POST /api/profile/presets/toremovegroup`
);
